import React, { useEffect, useState, useRef }  from 'react';
import Presenter from 'components/presenters/input/BottomTextArea';
import { convertViewPortWidthToPixel } from 'utils/utils.js';
import { FooterStateActions } from 'store/actionCreators';

const BottomTextArea = ({displayType='fixed', maxRow, minRow, textAreaStyle, bottomInputFocus, setBottomInputFocus,
                        onHeightChange, onSubmit, onChange, onFocus}) => {
    const totalAreaRef = useRef(null);
    const textAreaRef = useRef(null)
    const [textValue, setTextValue] = useState('');
    const [isValid, setIsValid] = useState(false);

    const defaultLineHeight = (textAreaStyle?.lineHeight) ? parseInt(textAreaStyle.lineHeight): 20;
    const adjustTextAreaRow = ()=>{
        textAreaRef.current.rows = 1;
        let currentRow = ~~(textAreaRef.current.scrollHeight / defaultLineHeight);
        if(maxRow && currentRow >= maxRow)
        {
            currentRow = maxRow
        }
        if(minRow && currentRow <= minRow)
        {
            currentRow = minRow;
        }
        textAreaRef.current.rows = currentRow;
        if(onHeightChange)onHeightChange(totalAreaRef.current.offsetHeight);
    }
    const handleOnChnage = (e) => {
        if(onChange)
        {
            onChange(e.target.value)
        }
        setTextValue(e.target.value);
    }

    const handleOnSubmit = (e) => {
        if(onSubmit) 
        {
            onSubmit();
        }
        setTextValue('');
    }
    useEffect(()=>{
        adjustTextAreaRow();
        if(textValue.length === 0)
        {
            setIsValid(false);
        }
        else
        {
            setIsValid(true);   
        }
    },[textValue])

    //init Row
    useEffect(()=>{
        textAreaRef.current.rows = (minRow)? minRow : 1;
    },[minRow])

    useEffect(()=>{
        if(textAreaStyle)
        {
            for (const key in textAreaStyle) {
                if(key !== 'lineHeight')
                {
                    textAreaRef.current.style[key] = textAreaStyle[key];
                }
            }
        }
        textAreaRef.current.style.lineHeight = `${convertViewPortWidthToPixel(100) * (defaultLineHeight/375)}px`;

    },[textAreaStyle, defaultLineHeight])

    useEffect(() => {
        if(![undefined, null].includes(bottomInputFocus) && bottomInputFocus === true)
        {
            textAreaRef.current.focus();
        }
    }, [bottomInputFocus])

    return (
        <Presenter 
            isValid={isValid}
            displayType={displayType}
            onChange={handleOnChnage} 
            onHeightChange={(height)=>{if(onHeightChange)onHeightChange(height);}} 
            textValue={textValue} 
            onSubmit={handleOnSubmit} 
            totalAreaRef={totalAreaRef} 
            textAreaRef={textAreaRef}
            setBottomInputFocus={setBottomInputFocus}
            onFocus={()=>{if(onFocus)onFocus()}}
        />);
}

export default BottomTextArea;